<template>
  <v-layout class="page-container" :style="`background-image: url('${backgroundImage}')`" row justify-center align-center>
    <v-card style="width: 100%; max-width: 500px;" class="elevation-24 ma-3">
      <v-card-title primary-title class="justify-center pb-0">
        <div>
          <img src="/static/logo-name.png" style="height: 60px">
        </div>
        <!-- <div class="headline">
          <div class="text-xs-center"> Sign In </div>
        </div> -->
      </v-card-title>
      <!-- <v-card-text class="py-0">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-form v-model="valid" ref="form" @submit.prevent="submit()" class="d-flex flex">
              <v-text-field
                label="Access Token"
                v-model="data.token"
                :rules="rules.token"
                required
              ></v-text-field>
            </v-form>
            <v-flex xs12>
              <v-alert transition="slide-y-transition" dismissible color="error" icon="warning" v-model="tokenInvalid">
                {{errorMessage}}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text> -->
      <v-card-actions class="justify-center pa-3 pb-4">
        <div class="text-xs-center">
          <v-alert class="mt-0 mb-3" transition="slide-y-transition" dismissible color="error" icon="warning" v-model="tokenInvalid">
            {{errorMessage}}
          </v-alert>
          <v-btn color="primary" dark @click="submit" :loading="loading" >
            <v-icon dark left>mdi-google-plus</v-icon>
            Sign In With Google
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import UserService from '../services/user.service'

export default {
  data: () => ({
    backgroundImage: require('../../public/static/login-bg.svg'),
    valid: true,
    tokenInvalid: false,
    errorMessage: '',
    loading: false,
    data: {
      token: null
    },
    rules: {
      token: [
        (v) => !!v || 'Access Token is required'
      ]
    }
  }),
  methods: {
    async submit () {
      this.tokenInvalid = false
      this.loading = true
      // Native form submission is not yet supported
      // const { token } = this.data
      try {
        await UserService.login()
        this.tokenInvalid = false
      } catch (e) {
        this.tokenInvalid = true
        this.errorMessage = e.message
      }
      this.loading = false
      if (!this.tokenInvalid) {
        this.$router.replace(this.$route.query.redirect || '/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-container {
    background-size: cover;
  }
</style>

